import React from 'react';
import DocumentHead from '../shared/DocumentHead';
import Header from '../shared/Header';

const NotFoundPage: React.FC = () => {
    return (
        <>
            <DocumentHead title=' - not found' />
            <Header headerClassName='mini'>
                <p>Page not found.</p>
            </Header>
        </>
    );
};

export default NotFoundPage;
